"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ua_parser_js_1 = require("ua-parser-js");
var MOBILE_DEVICE_TYPES = ['mobile', 'tablet'];
var Browser = /** @class */ (function () {
    function Browser(_a) {
        var userAgent = _a.userAgent, _b = _a.supported, supported = _b === void 0 ? true : _b;
        this.userAgent = userAgent;
        this.supported = supported;
        this.ua = new ua_parser_js_1.UAParser(userAgent);
    }
    Object.defineProperty(Browser.prototype, "name", {
        get: function () {
            return this.ua.getBrowser().name || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser.prototype, "version", {
        get: function () {
            return this.ua.getBrowser().version || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser.prototype, "majorVersion", {
        get: function () {
            var version = this.version;
            if (version === '') {
                return undefined;
            }
            var majorVersion = parseInt(version.split('.')[0], 10);
            return Number.isNaN(majorVersion) ? undefined : majorVersion;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser.prototype, "unknown", {
        get: function () {
            return this.name === '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser.prototype, "isMobile", {
        get: function () {
            return MOBILE_DEVICE_TYPES.includes(this.ua.getDevice().type);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser.prototype, "isDesktop", {
        get: function () {
            return !this.isMobile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser.prototype, "isNativeApp", {
        get: function () {
            return this.ua.getUA().includes('Shopify Mobile/', 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser.prototype, "os", {
        get: function () {
            return this.ua.getOS().name || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser.prototype, "isWindows", {
        get: function () {
            return this.os.includes('Windows');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser.prototype, "isMac", {
        get: function () {
            return this.os.includes('Mac OS');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser.prototype, "isSafari", {
        get: function () {
            return this.name.includes('Safari');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser.prototype, "isChrome", {
        get: function () {
            return this.name.includes('Chrome');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser.prototype, "isAndroidChrome", {
        get: function () {
            return this.ua.getUA().includes('Android') && this.name.includes('Chrome');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser.prototype, "isFirefox", {
        get: function () {
            return this.name === 'Firefox';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser.prototype, "isIE", {
        get: function () {
            return this.name.includes('IE');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser.prototype, "isEdge", {
        get: function () {
            return this.name === 'Edge';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Browser.prototype, "isIOS", {
        get: function () {
            var os = this.ua.getOS();
            var isStandardiOS = os.name && os.name.includes('iOS');
            var isShopifyiOS = /Shopify Mobile|Shopify POS|Shopify Ping/.test(this.userAgent) &&
                this.userAgent.includes('iOS');
            return isStandardiOS || isShopifyiOS;
        },
        enumerable: true,
        configurable: true
    });
    return Browser;
}());
exports.Browser = Browser;
function asPlainObject(browser) {
    if (browser == null) {
        return {};
    }
    return {
        name: browser.name,
        version: browser.version,
        isMobile: browser.isMobile,
        isNativeApp: browser.isNativeApp,
        isDesktop: browser.isDesktop,
    };
}
exports.asPlainObject = asPlainObject;
